import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit{

  public redirectUrl: string | null = '';
  public error: string | null = '';

  constructor(private route: ActivatedRoute) {}
  
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.redirectUrl = params.get('redirectUrl');
      this.error = params.get('errorDescription'); 
    });
  }
}
